export type ImageAlign = "left" | "center" | "right";

const ALIGN_SIDES: Record<ImageAlign, { left: string; right: string }> = {
  left: { left: "0", right: "auto" },
  center: { left: "auto", right: "auto" },
  right: { left: "auto", right: "0" },
};

const HORIZONTAL_MARGIN = /margin(?:-left|-right)?\s*:[^;]*;?/gi;

export const applyImageAlignToStyle = (
  style: string | null | undefined,
  align: ImageAlign,
): string => {
  const withoutHorizontal = (style ?? "")
    .replace(HORIZONTAL_MARGIN, "")
    .trim()
    .replace(/;+$/, "");
  const { left, right } = ALIGN_SIDES[align];
  const alignCss = `margin-left: ${left}; margin-right: ${right};`;
  return withoutHorizontal ? `${withoutHorizontal}; ${alignCss}` : alignCss;
};

const normalize = (value: string): string => value.trim().replace(/\s+/g, " ");

export const getImageAlignFromStyle = (
  style: string | null | undefined,
): ImageAlign | null => {
  if (!style) return null;

  const left = style.match(/margin-left\s*:\s*([^;]+)/i);
  const right = style.match(/margin-right\s*:\s*([^;]+)/i);
  if (left && right) {
    const l = normalize(left[1]);
    const r = normalize(right[1]);
    if (l === "0" && r === "auto") return "left";
    if (l === "auto" && r === "auto") return "center";
    if (l === "auto" && r === "0") return "right";
  }

  const shorthand = style.match(/(?:^|;)\s*margin\s*:\s*([^;]+)/i);
  if (!shorthand) return null;
  const value = normalize(shorthand[1]);
  if (value === "0 auto 0 0") return "left";
  if (value === "0 auto") return "center";
  if (value === "0 0 0 auto") return "right";
  return null;
};
